import { createWithEqualityFn } from 'zustand/traditional';
import { type AllLanguagesListResponseModel } from 'strapi/types';
import { shallow } from 'zustand/shallow';
import fetchWithFallback from 'services/CMSFetcher/fetchWithFallback';
import { LocalesState } from './types';

const compare = (a, b) => {
  return a === b || shallow(a, b);
};
const useLocalesStore = createWithEqualityFn<LocalesState>(
  set => ({
    locales: null,
    loading: true,
    setLocales: data => set({ locales: data, loading: false }),
    fetchLocales: () =>
      fetchWithFallback<AllLanguagesListResponseModel[]>('get-locales')
        .then(languages => {
          set({ loading: false, locales: languages });
        })
        .catch(() => set({ loading: false })),
  }),
  compare, // use shallow, when you have big objects and we need deep comparison (==) for avoid rerendering
);

export default useLocalesStore;
